/*
  V2 · Cada WhatsApp lleva su enlace (pedido de Boris, 12/10/2026).

  Al tocar cualquier enlace de WhatsApp, el mensaje suma «Estaba viendo: <enlace>».
  Así ventas abre exactamente lo que el cliente miraba. Si la ficha está configurada
  (medida, diseño, dedicatoria, medidas), el enlace reabre esa configuración.

  Cada componente puede registrar un «proveedor» que devuelve su enlace con estado:
    (window.tmEnlaceWA = window.tmEnlaceWA || { proveedores: [] }).proveedores.push(() => 'https://…');
  Si ninguno responde, se usa la página actual sin parámetros de seguimiento.
  Los datos personales (nombres, dedicatorias) viajan después del «#»: no llegan
  a los servidores ni a la analítica.
*/
(function () {
  var registro = window.tmEnlaceWA = window.tmEnlaceWA || { proveedores: [] };
  if (registro.listo) return;
  registro.listo = true;

  // Solo se conservan los parámetros que describen lo que el cliente estaba viendo.
  var UTILES = ['variant', 'tema', 'diseno', 'design', 'img', 'name', 'code', 'cat', 'ap', 'q', 'producto', 'tipo', 'sub'];

  function paginaActual() {
    var url = new URL(window.location.href);
    var limpia = new URL(url.origin + url.pathname);
    UTILES.forEach(function (clave) {
      var valor = url.searchParams.get(clave);
      if (valor) limpia.searchParams.set(clave, valor);
    });
    return limpia.href + (url.hash && url.hash.length > 1 ? url.hash : '');
  }

  function enlace() {
    for (var i = registro.proveedores.length - 1; i >= 0; i--) {
      try {
        var valor = registro.proveedores[i]();
        if (valor) return valor;
      } catch (error) { /* un proveedor roto no impide el mensaje */ }
    }
    return paginaActual();
  }
  registro.enlace = enlace;

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var a = event.target.closest && event.target.closest('a[href*="wa.me/"], a[href*="api.whatsapp.com/send"]');
    if (!a || a.hasAttribute('data-wa-sin-enlace')) return;
    var url;
    try { url = new URL(a.href); } catch (error) { return; }
    var texto = url.searchParams.get('text') || '';
    if (texto.indexOf(window.location.host) !== -1) return; // el componente ya puso su enlace
    var nuevo = (texto ? texto + '\n\n' : 'Hola! ') + 'Estaba viendo: ' + enlace();
    a.href = url.origin + url.pathname + '?text=' + encodeURIComponent(nuevo);
  }, true);
})();
